module.exports = __webpack_public_path__ + "img/mosaic.6ec520c8.png";